module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 105);
/******/ })
/************************************************************************/
/******/ ({

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/user-client"
var user_client_ = __webpack_require__(26);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/user-data"
var user_data_ = __webpack_require__(48);

// CONCATENATED MODULE: ./src/core/user/config.js
if (typeof window.isHidePhoneLoginValue === 'undefined') {
  window.isHidePhoneLoginValue = true;
}

/**
 * 允许手机号登录选项
 */
var enablePhoneLogin = function enablePhoneLogin() {
  window.isHidePhoneLoginValue = false;
};

/**
 * 禁止手机号登录选项
 */
var disablePhoneLogin = function disablePhoneLogin() {
  window.isHidePhoneLoginValue = true;
};
var isHidePhoneLogin = function isHidePhoneLogin() {
  return window.isHidePhoneLoginValue;
};
// CONCATENATED MODULE: ./src/core/user/index.js
/**
 * client：兼容app客户端bridge与browser浏览器【纯前端方法】
 * data：兼容app客户端本地获取用户信息与browser浏览器需调用爱玩后台接口获取信息【获取数据方法】
 */



/* harmony default export */ var user = __webpack_exports__["default"] = ({
  login: user_client_["login"],
  logout: user_client_["logout"],
  isLogin: user_client_["isLogin"],
  checkLogin: user_client_["checkLogin"],
  changeLogin: user_client_["changeLogin"],
  userCookie: user_client_["userCookie"],
  userKey: user_client_["userKey"],
  mainUserInfo: user_data_["mainUserInfo"],
  payVipInfo: user_data_["payVipInfo"],
  getCommonParams: user_client_["getCommonParams"],
  isHidePhoneLogin: isHidePhoneLogin,
  enablePhoneLogin: enablePhoneLogin,
  disablePhoneLogin: disablePhoneLogin,
  loginThenReload: user_client_["loginThenReload"]
});

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/user-client");

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/user-data");

/***/ })

/******/ })["default"];